import { AccionesRol, FuncionesRol } from 'modelos/src';

export const TODAS_LAS_ACCIONES: AccionesRol[] = [
  // *******************************************
  // EVENTOS
  // *******************************************
  'Eventos - Ver eventos',
  'Eventos - Atender eventos',
  'Eventos - Finalizar eventos',
  'Eventos - Ver eventos en atención',
  // *******************************************
  // LOGS
  // *******************************************
  'Logs - Ver logs http',
  'Logs - Ver logs eventos lora',
  'Logs - Ver logs despachos',
  'Logs - Ver logs eventos trackers test',
  'Logs - Ver logs reenvios',
  'Logs - Ver métricas downlinks',
  'Logs - Ver logs crudos alarmas',
  'Logs - Ver logs crudos trackers',
  'Logs - Ver logs crudos dashcams',
  // *******************************************
  // MODULO ADMINISTRACIÓN
  // *******************************************
  // Clientes
  'Administración - Ver clientes',
  'Administración - Crear clientes',
  'Administración - Editar clientes',
  'Administración - Eliminar clientes',
  'Administración - Deshabilitar / habilitar clientes',
  // Usuarios
  'Administración - Ver usuarios',
  'Administración - Crear usuarios',
  'Administración - Editar usuarios',
  'Administración - Eliminar usuarios',
  // Dispositivos Lorawan
  'Administración - Ver dispositivos Lorawan',
  'Administración - Crear dispositivos Lorawan',
  'Administración - Editar dispositivos Lorawan',
  'Administración - Eliminar dispositivos Lorawan',
  // Gateways
  'Administración - Ver gateways',
  'Administración - Crear gateways',
  'Administración - Editar gateways',
  'Administración - Eliminar gateways',
  // Botones Ble
  'Administración - Ver botones Ble',
  'Administración - Eliminar botones Ble',
  // Trackers
  'Administración - Ver trackers',
  'Administración - Crear trackers',
  'Administración - Editar trackers',
  'Administración - Eliminar trackers',
  // SIMs
  'Administración - Ver SIMs',
  'Administración - Crear SIMs',
  'Administración - Editar SIMs',
  'Administración - Eliminar SIMs',
  // Dashcams
  'Administración - Ver dashcams',
  'Administración - Crear dashcams',
  'Administración - Editar dashcams',
  'Administración - Eliminar dashcams',
  // Video de las dashcams: en vivo, grabaciones y evidencias de las alarmas
  'Dashcams - Ver en vivo',
  'Dashcams - Ver grabaciones',
  'Dashcams - Ver evidencias',
  // Servicios Ofrecidos
  'Administración - Ver servicios ofrecidos',
  'Administración - Crear servicios ofrecidos',
  'Administración - Editar servicios ofrecidos',
  'Administración - Eliminar servicios ofrecidos',
  // Apikeys
  'Administración - Ver apikeys',
  'Administración - Crear apikeys',
  'Administración - Editar apikeys',
  'Administración - Eliminar apikeys',
  // Config. de reenvios
  'Administración - Ver configuraciones de reenvíos',
  'Administración - Crear configuraciones de reenvíos',
  'Administración - Editar configuraciones de reenvíos',
  'Administración - Eliminar configuraciones de reenvíos',
  // Integraciones
  'Administración - Ver integraciones',
  'Administración - Crear integraciones',
  // Roles
  'Administración - Ver roles',
  'Administración - Crear roles',
  'Administración - Editar roles',
  'Administración - Eliminar roles',
  // Eventos Personalizados
  'Administración - Ver eventos personalizados',
  'Administración - Crear eventos personalizados',
  'Administración - Editar eventos personalizados',
  'Administración - Eliminar eventos personalizados',
  // Categorías Eventos
  'Administración - Ver categorias eventos',
  'Administración - Crear categorias eventos',
  'Administración - Editar categorias eventos',
  'Administración - Eliminar categorias eventos',
  // Tipos de Eventos (listado categorias)
  'Administración - Ver listado categorias',
  'Administración - Crear listado categorias',
  'Administración - Editar listado categorias',
  'Administración - Eliminar listado categorias',
  // Inactividad de usuarios
  'Administración - Ver inactividad usuarios',
  // Periodo de actividad de usuarios
  'Administración - Ver periodo actividad usuarios',
  // *******************************************
  // CONFIGURACIONES
  // *******************************************
  'Configuraciones - Configurar cliente',
  'Configuraciones - Crear codigos alarmas',
  'Configuraciones - Editar codigos alarmas',
  'Configuraciones - Eliminar codigos alarmas',
  'Configuraciones - Crear modelos alarmas',
  'Configuraciones - Editar modelos alarmas',
  'Configuraciones - Eliminar modelos alarmas',
  'Configuraciones - Crear codigos comunicadores',
  'Configuraciones - Editar codigos comunicadores',
  'Configuraciones - Eliminar codigos comunicadores',
  'Configuraciones - Crear modelos comunicadores',
  'Configuraciones - Editar modelos comunicadores',
  'Configuraciones - Eliminar modelos comunicadores',
  'Configuraciones - Crear modelos cámaras',
  'Configuraciones - Editar modelos cámaras',
  'Configuraciones - Eliminar modelos cámaras',
  'Configuraciones - Crear codigos sirenas',
  'Configuraciones - Editar codigos sirenas',
  'Configuraciones - Eliminar codigos sirenas',
  'Configuraciones - Crear modelos sirenas',
  'Configuraciones - Editar modelos sirenas',
  'Configuraciones - Eliminar modelos sirenas',
  'Configuraciones - Crear modelos luminarias',
  'Configuraciones - Editar modelos luminarias',
  'Configuraciones - Eliminar modelos luminarias',
  'Configuraciones - Crear perfiles luminarias',
  'Configuraciones - Editar perfiles luminarias',
  'Configuraciones - Eliminar perfiles luminarias',
  'Configuraciones - Crear codigos dispositivos lorawan',
  'Configuraciones - Editar codigos dispositivos lorawan',
  'Configuraciones - Eliminar codigos dispositivos lorawan',
  'Configuraciones - Crear modelos dispositivos lorawan',
  'Configuraciones - Editar modelos dispositivos lorawan',
  'Configuraciones - Eliminar modelos dispositivos lorawan',
  'Configuraciones - Crear codigos botones BLE',
  'Configuraciones - Editar codigos botones BLE',
  'Configuraciones - Eliminar codigos botones BLE',
  'Configuraciones - Crear modelos botones BLE',
  'Configuraciones - Editar modelos botones BLE',
  'Configuraciones - Eliminar modelos botones BLE',
  'Configuraciones - Crear codigos trackers',
  'Configuraciones - Editar codigos trackers',
  'Configuraciones - Eliminar codigos trackers',
  'Configuraciones - Crear modelos trackers',
  'Configuraciones - Editar modelos trackers',
  'Configuraciones - Eliminar modelos trackers',
  'Configuraciones - Crear codigos dashcams',
  'Configuraciones - Editar codigos dashcams',
  'Configuraciones - Eliminar codigos dashcams',
  'Configuraciones - Crear modelos dashcams',
  'Configuraciones - Editar modelos dashcams',
  'Configuraciones - Eliminar modelos dashcams',
  'Configuraciones - Crear iconos vehículos',
  'Configuraciones - Editar iconos vehículos',
  'Configuraciones - Eliminar iconos vehículos',
  // *******************************************
  // MODULO SERVICIO TECNICO
  // *******************************************
  // Técnicos
  'Servicio Técnico - Ver técnicos',
  'Servicio Técnico - Crear técnicos',
  'Servicio Técnico - Editar técnicos',
  'Servicio Técnico - Eliminar técnicos',
  // Solicitudes
  'Servicio Técnico - Ver solicitudes',
  'Servicio Técnico - Crear solicitudes',
  'Servicio Técnico - Editar solicitudes',
  'Servicio Técnico - Eliminar solicitudes',
  'Servicio Técnico - Reasignar solicitudes',
  'Servicio Técnico - Atender solicitudes',
  'Servicio Técnico - Ver pedidos de materiales',
  'Servicio Técnico - Gestionar pedidos de materiales',
  // *******************************************
  // MODULO ALARMAS
  // *******************************************
  'Alarmas - Crear',
  'Alarmas - Editar',
  'Alarmas - Eliminar',
  'Alarmas - Exportar eventos',
  'Alarmas - Dar de alta',
  'Alarmas - Actualizar imágenes',
  'Alarmas - Cambiar de cliente',
  'Alarmas - Configurar comunicador',
  'Alarmas - Solicitar servicio técnico',
  'Alarmas - Cambiar estado de cuenta',
  'Alarmas - Cambiar modo desactivado',
  'Alarmas - Editar control horario',
  'Alarmas - Editar contactos ',
  'Alarmas - Editar notas',
  'Alarmas - Asignar cámaras',
  'Alarmas - Enviar comandos',
  // Zonas
  'Alarmas - Crear zonas',
  'Alarmas - Editar zonas',
  'Alarmas - Eliminar zonas',
  // *******************************************
  // MODULO VEHÍCULOS
  // *******************************************
  // Vehículos
  'Vehículos - Crear',
  'Vehículos - Editar',
  'Vehículos - Eliminar',
  'Vehículos - Exportar eventos',
  'Vehículos - Exportar Reportes',
  'Vehículos - Dar de alta',
  'Vehículos - Actualizar imágenes',
  'Vehículos - Modo estacionado',
  'Vehículos - Cambiar modo desactivado',
  'Vehículos - Cambiar de cliente',
  'Vehículos - Solicitar servicio técnico',
  'Vehículos - Enviar comandos',
  'Vehículos - Editar contactos ',
  'Vehículos - Editar notas',
  'Vehículos - Editar documentos vehículo',
  // Conductores
  'Vehículos - Crear conductor',
  'Vehículos - Editar conductor',
  'Vehículos - Eliminar conductor',
  'Vehículos - Asignar conductor',
  'Vehículos - Crear documentos conductor',
  'Vehículos - Editar documentos conductor',
  'Vehículos - Eliminar documentos conductor',
  // zonas, recorridos, flotas, recordatorios, servicios y proveedores
  'Vehículos - Crear zonas',
  'Vehículos - Editar zonas',
  'Vehículos - Eliminar zonas',
  'Vehículos - Crear recorridos',
  'Vehículos - Editar recorridos',
  'Vehículos - Eliminar recorridos',
  'Vehículos - Crear flotas',
  'Vehículos - Editar flotas',
  'Vehículos - Eliminar flotas',
  'Vehículos - Crear recordatorios',
  'Vehículos - Editar recordatorios',
  'Vehículos - Eliminar recordatorios',
  'Vehículos - Crear servicios',
  'Vehículos - Editar servicios',
  'Vehículos - Eliminar servicios',
  'Vehículos - Crear proveedores',
  'Vehículos - Editar proveedores',
  'Vehículos - Eliminar proveedores',
  // *******************************************
  // MODULO LUMINARIAS
  // *******************************************
  'Luminarias - Crear',
  'Luminarias - Editar',
  'Luminarias - Eliminar',
  'Luminarias - Cambiar de cliente',
  'Luminarias - Enviar comandos',
  'Luminarias - Solicitar servicio técnico',
  'Luminarias - Editar contactos ',
  'Luminarias - Editar notas',
  // Agrupaciones
  'Luminarias - Crear agrupaciones',
  'Luminarias - Editar agrupaciones',
  'Luminarias - Eliminar agrupaciones',
  // Puestas
  'Luminarias - Crear puestas',
  'Luminarias - Editar puestas',
  'Luminarias - Eliminar puestas',
  // Zonas
  'Luminarias - Crear zonas',
  'Luminarias - Editar zonas',
  'Luminarias - Eliminar zonas',
  // *******************************************
  // MODULO ACTIVOS
  // *******************************************
  // Activos
  'Activos - Crear',
  'Activos - Editar',
  'Activos - Eliminar',
  'Activos - Exportar eventos',
  'Activos - Exportar Reportes',
  // 'Activos - Dar de alta' // No esta implementado pero quizá se implemente en un futuro,
  // 'Activos - Actualizar imágenes' // No esta implementado pero quizá se implemente en un futuro,
  'Activos - Cambiar modo desactivado',
  'Activos - Cambiar de cliente',
  'Activos - Cambiar estado de cuenta',
  'Activos - Solicitar servicio técnico',
  // 'Activos - Enviar comandos' // No esta implementado pero quizá se implemente en un futuro,
  'Activos - Editar contactos ',
  'Activos - Editar notas',
  // Ubicaciones, agrupaciones
  'Activos - Crear ubicaciones',
  'Activos - Editar ubicaciones',
  'Activos - Eliminar ubicaciones',
  'Activos - Crear agrupaciones',
  'Activos - Editar agrupaciones',
  'Activos - Eliminar agrupaciones',
  // *******************************************
  // MODULO TRASNPORTE PUBLICO / COLECTIVOS
  // *******************************************
  // Colectivos
  'Colectivos - Crear',
  'Colectivos - Editar',
  'Colectivos - Eliminar',
  'Colectivos - Exportar eventos',
  'Colectivos - Exportar Reportes',
  // 'Colectivos - Dar de alta' // No esta implementado pero quizá se implemente en un futuro,
  // 'Colectivos - Actualizar imágenes' // No esta implementado pero quizá se implemente en un futuro,
  'Colectivos - Cambiar modo desactivado',
  // 'Colectivos - Cambiar de cliente' // No esta implementado pero quizá se implemente en un futuro,
  'Colectivos - Solicitar servicio técnico',
  'Colectivos - Setear odómetro',
  // 'Colectivos - Enviar comandos' // No esta implementado pero quizá se implemente en un futuro,
  'Colectivos - Editar contactos ',
  'Colectivos - Editar notas',
  'Colectivos - Editar documentos colectivo',
  // Recorridos, terminales, líneas, choferes, cronogramas, recordatorios, servicios y proveedores
  'Colectivos - Crear recorridos',
  'Colectivos - Editar recorridos',
  'Colectivos - Eliminar recorridos',
  'Colectivos - Crear terminales',
  'Colectivos - Editar terminales',
  'Colectivos - Eliminar terminales',
  'Colectivos - Crear líneas',
  'Colectivos - Editar líneas',
  'Colectivos - Eliminar líneas',
  'Colectivos - Crear choferes',
  'Colectivos - Editar choferes',
  'Colectivos - Eliminar choferes',
  'Colectivos - Crear cronogramas',
  'Colectivos - Editar cronogramas',
  'Colectivos - Eliminar cronogramas',
  'Colectivos - Crear recordatorios',
  'Colectivos - Editar recordatorios',
  'Colectivos - Eliminar recordatorios',
  'Colectivos - Crear servicios',
  'Colectivos - Editar servicios',
  'Colectivos - Eliminar servicios',
  'Colectivos - Crear proveedores',
  'Colectivos - Editar proveedores',
  'Colectivos - Eliminar proveedores',
  // *******************************************
  // MODULO EMERGENCIAS MÉDICAS
  // *******************************************
  // Emergencias Médicas
  'Emergencias Médicas - Crear',
  'Emergencias Médicas - Importar',
  'Emergencias Médicas - Editar',
  'Emergencias Médicas - Eliminar',
  'Emergencias Médicas - Reasignar',
  'Emergencias Médicas - Finalizar',
  'Emergencias Médicas - Cancelar',
  // Hospitales, centros médicos, personal de salud, solicitantes, pacientes
  'Emergencias Médicas - Crear hospitales',
  'Emergencias Médicas - Editar hospitales',
  'Emergencias Médicas - Eliminar hospitales',
  'Emergencias Médicas - Crear centros médicos',
  'Emergencias Médicas - Editar centros médicos',
  'Emergencias Médicas - Eliminar centros médicos',
  'Emergencias Médicas - Crear personal de salud',
  'Emergencias Médicas - Editar personal de salud',
  'Emergencias Médicas - Eliminar personal de salud',
  'Emergencias Médicas - Crear solicitantes',
  'Emergencias Médicas - Editar solicitantes',
  'Emergencias Médicas - Eliminar solicitantes',
  'Emergencias Médicas - Crear pacientes',
  'Emergencias Médicas - Editar pacientes',
  'Emergencias Médicas - Eliminar pacientes',
  // *******************************************
  // MODULO SIRENAS MUNICIPALES
  // *******************************************
  // Sirenas Municipales
  'Sirenas Municipales - Sincronizar',
  'Sirenas Municipales - Editar',
  'Sirenas Municipales - Eliminar',
  'Sirenas Municipales - Solicitar servicio técnico',
  'Sirenas Municipales - Asignar cámaras',
  // *******************************************
  // MODULO ALERTAS DE SEGURIDAD
  // *******************************************
  'Alertas Seguridad - Crear',
  'Alertas Seguridad - Atender',
  'Alertas Seguridad - Derivar',
  'Alertas Seguridad - Exportar',
  // *******************************************
  // MODULO CÁMARAS
  // *******************************************
  // Cámaras
  'Cámaras - Crear cámara',
  'Cámaras - Editar cámara',
  'Cámaras - Eliminar cámara',
  'Cámaras - Solicitar servicio técnico',
  'Cámaras - Ver streaming',
  'Cámaras - Descargar grabaciones',
  // *******************************************
  // MÓDULO FACTURACIÓN
  // *******************************************
  // Tablero
  'Facturación - Ver panel',
  // Productos
  'Facturación - Ver productos',
  'Facturación - Crear productos',
  'Facturación - Editar productos',
  // Precios
  'Facturación - Ver precios',
  'Facturación - Crear precios',
  // Contrataciones
  'Facturación - Ver contrataciones',
  'Facturación - Crear contrataciones',
  'Facturación - Dar de baja contrataciones',
  'Facturación - Asignar masivamente',
  'Facturación - Importar contrataciones',
  // Liquidaciones
  'Facturación - Ver liquidaciones',
  'Facturación - Emitir liquidaciones',
  'Facturación - Aplicar ajustes',
  'Facturación - Anular liquidaciones',
  'Facturación - Exportar liquidaciones',
  // Configuración e importes
  'Facturación - Editar configuración de facturación',
  'Facturación - Ver importes',
  // *******************************************
  // MÓDULO AUDITORÍAS
  // *******************************************
  'Auditorías - Ver auditorías',
];

export const TODAS_LAS_FUNCIONES: {
  funcion: FuncionesRol;
  descripcion: string;
}[] = [
  {
    funcion: 'Técnico',
    descripcion:
      'Para elegir técnicos en solicitudes de servicio técnico y para vista especial en la app mobile. Asignable a vehículos (no colectivos)',
  },
  {
    funcion: 'Conductor',
    descripcion: 'Asignable a vehículos (no colectivos)',
  },
  {
    funcion: 'Chofer',
    descripcion: 'Asignable a colectivos',
  },
  {
    funcion: 'Móvil Emergencias Médicas',
    descripcion:
      'Funciones especiales para emergencias médicas en app mobile. Asignable a vehículos (no colectivos)',
  },
];

export const TOTAL_ACCIONES = TODAS_LAS_ACCIONES.length;
